/* oxlint-disable typescript/no-non-null-assertion */

import { connect } from 'react-redux';
import { IGetVillageListRequestSchema } from '../../../../node/repositories/countryside-search/entities/schemas/GetVillageListRequestSchema';
import { IVillageForListPresenterSchema } from '../../../../node/repositories/countryside-search/entities/village/VillageForListPresenterSchema';
import { IApplicationState, TTypedThunkDispatch } from '../../../types/store';

import { getDefaultVillageListRequest } from '../../../interfaces/villages';
import { changePage } from '../../../store/filters/actions';
import { MobileList } from './index';
import { chunk } from '../../../utils/chunk';

export interface IMobileListStoreProps {
  filters: IGetVillageListRequestSchema;
  regionHasRoads: boolean;
  paginatedList?: IVillageForListPresenterSchema[][];
  isShowMoreVisible?: boolean;
  isFetching: boolean;
}

export interface IMobileListDispatchProps {
  fetchVillages(page: number): void;
}

export type TMobileListProps = IMobileListStoreProps & IMobileListDispatchProps;

export function mapStateToProps(state: IApplicationState): IMobileListStoreProps {
  const {
    villageList: { villageList = [], totalPages },
    isFetching,
    filters,
    roads: { regionHasRoads },
  } = state;
  const { p = 1 } = filters;
  const paginatedList = villageList!.length ? chunk(villageList!, getDefaultVillageListRequest().pageSize) : undefined;

  return {
    isFetching,
    isShowMoreVisible: p! < totalPages!,
    filters,
    paginatedList,
    regionHasRoads,
  };
}

export function mapDispatchToProps(dispatch: TTypedThunkDispatch): IMobileListDispatchProps {
  return {
    fetchVillages: (value: number) => dispatch(changePage(value)),
  };
}

export const MobileListContainer = connect<IMobileListStoreProps, IMobileListDispatchProps>(
  mapStateToProps,
  mapDispatchToProps,
)(MobileList);
